import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useStoreActions, useStoreState } from 'store'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from 'sweetalert2'
import { sdocUser } from 'api'
import { now } from '../../../../../../node_modules/moment/moment'
import { useTranslation } from 'hooks/useTranslation'
const useStyles = makeStyles({
	table: {
		width: '100%',
	},
})

export default function TablePOA(props) {
	const classes = useStyles()
	const { t } = useTranslation()
	const { token } = props
	const { data } = useStoreState(state => state.poa)
	const selectPOA = useStoreActions(action => action.poa.setSelected)
	const [loading, setLoading] = useState(false)
	const [loadingShop, setLoadingShop] = useState(false)
	const [shopList, setShopList] = useState([])

	const fetchShopData = async () => {
		setLoadingShop(true)
		const isEnabled = true // true = use real api, false = use mock

		if (isEnabled) {
			try {
				const res = await sdocUser.getShopProfiles(token)
				if (res && res.status === 200) {
					let shopData = res.data;
					if (!shopData) shopData = [];

					// Handle potential double encoding or string response
					if (typeof shopData === 'string') {
						try {
							shopData = JSON.parse(shopData);
						} catch (e) {
							console.warn('Failed to parse shop data string', e);
							shopData = [];
						}
					}

					// Ensure it is an array
					if (!Array.isArray(shopData) && shopData) {
						// Sometimes it might be wrapped? or just one object?
						// User example: "[{...}]". So expect array.
						shopData = [shopData];
					}

					if (Array.isArray(shopData)) {
						if (shopData.length === 0) {
							Swal.fire({
								title: t('auth.noShopTitle'),
								text: t('auth.noShopText'),
								icon: 'warning',
								confirmButtonText: t('auth.ok'),
								didOpen: () => {
									const container = Swal.getContainer();
									if (container) container.style.zIndex = '10000';
								}
							})
						}
						setShopList(shopData)
					}
				} else {
					console.error('Failed to fetch shop data', res);
					// Optionally show error snackbar
					Swal.fire({
						title: t('auth.shopErrorTitle'),
						text: t('auth.shopErrorText'),
						icon: 'error',
						confirmButtonText: t('auth.ok'),
						didOpen: () => {
							const container = Swal.getContainer();
							if (container) container.style.zIndex = '10000';
						}
					})
				}
			} catch (error) {
				console.error('Error fetching shop data', error);
			} finally {
				setLoadingShop(false)
			}
		} else {
			// Mock API call
			setTimeout(() => {
				const mockData = [
					{
						"TaxId": "1100702356139",
						"BranchId": "00001",
						"FullnameTH": "ร้านร้านทดสอบ โดย นายกันตพงศ์ เฉลิมกิจวณิชย์",
						"FullnameEN": "Tester Shop By Mister Kantapong Chaloemkitwanit",
						"FullAddress": "8/135\nแขวงบางแคเหนือ เขตบางแค กรุงเทพมหานคร 10160 Thailand",
						"AddressNo": "8/135",
						"Building": null,
						"RoomNo": null,
						"Floor": null,
						"VillageName": null,
						"Moo": null,
						"Soi": null,
						"Road": null,
						"SubDistrictCode": "104002",
						"SubDistrict": "บางแคเหนือ",
						"DistrictCode": "1040",
						"District": "บางแค",
						"ProvinceCode": "10",
						"Province": "กรุงเทพมหานคร",
						"Postcode": "10160",
						"Phone": null,
						"Fax": null,
						"Email": "tangyoza56@gmail.com",
						"ModifiedDate": "2025-11-19T14:58:50"
					},
					{
						"TaxId": "9999999999999",
						"BranchId": "00002",
						"FullnameTH": "ร้านค้าทดสอบที่ 2",
						"FullnameEN": "Tester Shop 2",
						"FullAddress": "99/99\nแขวงตัวอย่าง เขตตัวอย่าง กรุงเทพมหานคร 10000 Thailand",
						"AddressNo": "99/99",
						"Building": "อาคารตัวอย่าง",
						"RoomNo": "1",
						"Floor": "1",
						"VillageName": null,
						"Moo": null,
						"Soi": null,
						"Road": null,
						"SubDistrictCode": "100001",
						"SubDistrict": "ตัวอย่าง",
						"DistrictCode": "1000",
						"District": "เขตตัวอย่าง",
						"ProvinceCode": "10",
						"Province": "กรุงเทพมหานคร",
						"Postcode": "10000",
						"Phone": "02-123-4567",
						"Fax": null,
						"Email": "test@example.com",
						"ModifiedDate": "2025-11-20T10:00:00"
					}
				]
				setShopList(mockData)
				setLoadingShop(false)
			}, 500)
		}
	}

	useEffect(() => {
		// console.log('data',data)
		selectPOA(null)
		// eslint-disable-next-line
	}, [])

	return (
		<TableContainer component={Paper}>
			<Table className={classes.table} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>{t('auth.taxId')}</TableCell>

						<TableCell>{t('auth.authPeriod')}</TableCell>
						<TableCell>{t('auth.operatorName')}</TableCell>
						<TableCell align="right"></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					<TableRow key="0">
						<TableCell component="td" scope="row">
							-
						</TableCell>
						<TableCell component="td" scope="row">
							-
						</TableCell>
						<TableCell component="td" scope="row">
							{t('auth.individual')}
						</TableCell>
						<TableCell align="right">
							<Button
								className="w-5/12"
								onClick={e => {
									selectPOA(0)
									setLoading(true)
								}}
								disabled={loading || loadingShop}
								color="primary"
								variant="contained">{t('auth.select')}</Button>
						</TableCell>
					</TableRow>
					<TableRow key="view-shop">
						<TableCell component="td" scope="row">
							-
						</TableCell>
						<TableCell component="td" scope="row">
							-
						</TableCell>
						<TableCell align="right" colSpan={2}>
							<Button
								className="w-5/12"
								onClick={fetchShopData}
								disabled={loading || loadingShop}
								color="default"
								variant="outlined">
								{loadingShop && <CircularProgress size={20} className="mr-2" />}
								{t('auth.viewShop')}
							</Button>
						</TableCell>
					</TableRow>
					{shopList.map((shop, index) => (
						<TableRow key={`shop-${index}`}>
							<TableCell component="td" scope="row">
								{shop.TaxId}
							</TableCell>
							<TableCell component="td" scope="row">
								-
							</TableCell>
							<TableCell component="td" scope="row">
								{shop.FullnameTH}
							</TableCell>
							<TableCell align="right">
								<Button
									className="w-5/12"
									onClick={e => {
										selectPOA({ ...shop, isShop: true })
										setLoading(true)
									}}
									disabled={loading}
									color="primary"
									variant="contained">{t('auth.select')}</Button>
							</TableCell>
						</TableRow>
					))}
					{data.map(row => {
						var exp = new Date(new String(row.expireDate).split('/')[2] + '-' + new String(row.expireDate).split('/')[1] + '-' + new String(row.expireDate).split('/')[0])
						// if (row.expireDate == null){
						// 	// if expireDate is null, set expireDate to today + 1 day
						// 	exp = new Date()
						// 	exp.setDate(exp.getDate() + 7)
						// }
						var now = new Date()
						exp.setDate(exp.getDate() + 1)
						// console.log('exp', exp.getTime())
						// console.log('now', now.getTime())
						if (exp.getTime() >= now.getTime() || true) {
							return (
								<TableRow key={row.juristicNo}>
									<TableCell component="td" scope="row">
										{row.juristicNo}
									</TableCell>
									<TableCell component="td" scope="row">
										{row.startDate} {t('auth.to')} {row.expireDate ? row.expireDate : t('auth.noExpiry')}
									</TableCell>
									<TableCell component="td" scope="row">
										{row.operator ? row.operator.operatorName : t('auth.notInSystem')}
									</TableCell>
									<TableCell align="right">
										<Button
											className="w-5/12"
											onClick={e => {
												selectPOA(row)
												setLoading(true)
											}}
											disabled={loading}
											color="primary"
											variant="contained">
											{loading && <CircularProgress size={25} />}
											{!loading && t('auth.select')}
										</Button>
									</TableCell>
								</TableRow>
							)
						}
					})}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
